import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
  filters: {
    search_text: "",
    myobStatus: "",
    vendorId: "",
    startDate: moment().startOf("day").format("YYYY-MM-DD"),
    endDate: moment().endOf("day").format("YYYY-MM-DD"),
    searchRange: "1month",
  },
  sorting: {
    sortField: "order_number",
    sortDirection: "-1",
  },
};

const masterPurchaseOrderSlice = createSlice({
  name: "purchaseOrders",
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    setSorting(state, action) {
      state.sorting = action.payload;
    },
    resetFiltersAndSorting(state) {
      state.filters = initialState.filters;
      state.sorting = initialState.sorting;
    },
  },
});

export const { setFilters, setSorting, resetFiltersAndSorting } = masterPurchaseOrderSlice.actions;
export default masterPurchaseOrderSlice.reducer;
